import {Block} from 'blocks/block'
import {Theme} from 'layout/theme'
import React from 'react'
import {DPProcessBlock} from 'types/DPTypes'
import {Link} from 'util/link'
import {fromModule} from 'util/styler/Styler'
import {useIDFromAnchorBlock} from 'util/useAnchor'
import css from './process.module.scss'

const styles = fromModule(css)

export const Process: React.FC<DPProcessBlock> = (data) => {
	const {_type, text, links} = data
	const hasLinks = links && links.length > 0
	const id = useIDFromAnchorBlock(data)
	if (!text && !hasLinks) return null

	return (
		<Block
			type={_type}
			className={styles.process.mod({links: hasLinks})()}
			anchorID={id}
		>
			<Theme.Container>
				{text && (
					<div className={styles.process.text()}>
						<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
					</div>
				)}
			</Theme.Container>
			{hasLinks && (
				<div className={styles.process.links()}>
					<Theme.Container>
						<div className={styles.process.links.items()}>
							{links.map((link, i) => (
								<div key={i} className={styles.process.links.item()}>
									<Link href={link.url} className={styles.process.links.link()}>
										{link.title}
									</Link>
								</div>
							))}
						</div>
					</Theme.Container>
				</div>
			)}
		</Block>
	)
}
